import { Component, computed, inject } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';
import { TranslocoPipe, TranslocoService } from '@ngneat/transloco';
import { openClose } from '../../shared/animations/animations';
import { IconNameType } from '../../shared/icons/icon-name-type.enum';
import { FeedbackTextComponent } from "../../shared/feedback-text/feedback-text.component";
import { ModalName, ModalService } from '../../core/services/modal.service';
import { ErrorsService } from '../../core/services/errors.service';
import { RoundIconComponent } from "../../shared/round-icon/round-icon.component";
import { IconComponent } from "../../shared/icons/icon.component";
import { ToastService } from '../../core/services/toast.service';
import { DeployUrlPipe } from '../../core/pipes/deploy-url.pipe';

@Component({
  selector: 'cwo-verify-email-modal',
  standalone: true,
  imports: [TranslocoPipe, FeedbackTextComponent, RoundIconComponent, IconComponent, DeployUrlPipe],
  templateUrl: './verify-email-modal.component.html',
  styleUrl: './verify-email-modal.component.scss',
  animations: [openClose()],
})
export class VerifyEmailModalComponent {
  authService = inject(AuthService);
  modalService = inject(ModalService);
  errorService = inject(ErrorsService);
  translocoService = inject(TranslocoService);
  toastService = inject(ToastService);
  iconNameType = IconNameType;
  feedbackText?: string;
  feedbackType: 'error' | 'success' | 'none' = 'none';
  loading = false;

  accountEmail = computed(() => {
    return this.authService.state().account?.email;
  });

  closeModal() {
    this.modalService.closeModal(ModalName.VerifyEmail);
  }

  resendVerificationEmail() {
    const email = this.accountEmail();
    if (!email) {
      return;
    }
    this.loading = true;
    this.authService.resendVerificationEmail(email).subscribe({
      next: () => {
      this.loading = false;
      this.toastService.showSuccess(this.translocoService.translate('modals.verify_email.verification_email_sent'));
      },
      error: (error) => {
        this.loading = false;
        const parsedError = this.errorService.parseAllErrorsFromResponse(error);
        this.feedbackType = 'error';
        this.feedbackText = parsedError.allErrors[0];
      }
    });
  }
}
